export default __webpack_public_path__ + "static/bushells-0e96b0d07d93d5eec4c7813a72a653f9.png";